export default __webpack_public_path__ + "static/media/coyu.d33a75fd.jpg";